import { render } from "./modal_notification.vue?vue&type=template&id=70b09a1a&scoped=true"
import script from "./modal_notification.vue?vue&type=script&lang=js"
export * from "./modal_notification.vue?vue&type=script&lang=js"

import "./modal_notification.vue?vue&type=style&index=0&id=70b09a1a&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b09a1a"]])

export default __exports__